import React from "react";
import { immunizationsNJPrivacyPdfURL } from "../utils/data";
import { TFunction } from "i18next";

interface TextProps {
  text: string;
  url?: string;
}

interface LinkProps {
  texts: TextProps[];
}

export const paragraphWithLinks = ({ texts }: LinkProps) => {
  return (
    <div>
      {texts.map((text: TextProps, index: number) => {
        return (
          <p key={index} role="paragraph">
            {!text.url && <p>{text.text}</p>}
            {text.url && <a href={text.url}>{text.text}</a>}
          </p>
        );
      })}
    </div>
  );
};

export const utSearchFooter = (t: TFunction) => {
  return (
    <div>
      <span className="font-bold">Utah:</span>{" "}
      <span className="text-sm">{t("immunizations.search_records_legal", { context: "ut" })}</span>
    </div>
  );
};

export const njSearchFooter = (t: TFunction) => {
  return (
    <div className="max-md:text-white">
      <span className="font-bold">New Jersey:</span>{" "}
      <span className="text-sm">{t("immunizations.search_records_legal", { context: "nj" })}</span>
      <a href={immunizationsNJPrivacyPdfURL} target="_blank" className="link link-primary">
        {"New Jersey's Privacy Notice."}
      </a>
    </div>
  );
};

export const mnSearchFooter = (t: TFunction) => {
  return (
    <div>
      <span className="font-bold">Minnesota:</span>{" "}
      <span className="text-sm">{t("immunizations.search_records_legal", { context: "mn" })}</span>
      <a
        href={"https://www.health.state.mn.us/people/immunize/miic/records.html"}
        target="_blank"
        className="link link-primary"
      >
        {" "}
        {"Minnesota Department of Health"}
      </a>
    </div>
  );
};

export const idSearchFooter = (t: TFunction) => {
  return (
    <div>
      <span className="font-bold">Idaho:</span>{" "}
      <span className="text-sm">{t("immunizations.search_records_legal", { context: "id" })}</span>
      <br />
      <a
        href={"https://healthandwelfare.idaho.gov/news-notices/public-records-requests"}
        target="_blank"
        className="link link-primary"
      >
        {t("immunizations.search_records_legal", { context: "id_link" })}
      </a>
      <br />
      <a
        href={"https://healthandwelfare.idaho.gov/about-dhw/privacy-and-confidentiality"}
        target="_blank"
        className="link link-primary"
      >
        {"Idaho Department of Health and Welfare Privacy Policy"}
      </a>
    </div>
  );
};

export const akSearchFooter = (t: TFunction) => {
  return (
    <div>
      <span className="font-bold">Alaska:</span>{" "}
      <span className="text-sm">{t("immunizations.search_records_legal", { context: "ak" })}</span>
    </div>
  );
};
